import { getRemoteConfig, isSupported as isRemoteConfigSupported } from 'firebase/remote-config';
import { firebaseConfig } from '~/configs/firebase';
import { initializeApp } from 'firebase/app';

export const useRemoteConfig = async (
  defaultConfig: Record<string, string | number | boolean>
) => {
  const supported = await isRemoteConfigSupported();

  if (supported) {
    const app = initializeApp(firebaseConfig);
    const remoteConfigValues = getRemoteConfig(app);

    remoteConfigValues.settings = {
      fetchTimeoutMillis: 60000,
      minimumFetchIntervalMillis: 1,
    };
    remoteConfigValues.defaultConfig = defaultConfig;

    return remoteConfigValues;
  }

  return null;
};
